<template>
    <div>
        <v-layout align-center justify-center>
            <v-flex xs12 sm12 md12 lg12 xl12 style="text-align: center;">
                <v-card class="elevation-1">
                    <v-card-text style="text-align: center">
                        <h3>{{$t("lang.exercise.essayQuestion")}}</h3>
                        <v-form @keyup.enter.native="onSave">
                            <v-layout wrap>
                                <v-flex xs12 sm12 md8 lg8 xl8
                                        style="border:1px solid gray; border-radius:5px;padding:10px;max-height: 800px;overflow: auto">
                                    <v-btn @click="fromLocal" style="margin-right: 10px">
                                        <v-icon dark left>desktop_windows</v-icon>
                                        {{ $t('lang.exercise.fromLocal') }}
                                    </v-btn>
                                    <input type="file" id="essayUpload" style="display: none" class="file"
                                           @change="onFilePicked"
                                           :accept="accept"/>
                                    <v-btn @click="fromLibary">
                                        <v-icon dark left>library_add</v-icon>
                                        {{ $t('lang.exercise.fromLibrary') }}
                                    </v-btn>
                                    <table class="lstTable" v-if="attachs.length>0">
                                        <tr class="yoprimary">
                                            <td colspan="2">Danh sách tệp câu hỏi</td>
                                        </tr>
                                        <tr v-for="att in attachs" :key="att+att.attachId">
                                            <td style="text-align: left"><a
                                                    @click="viewAtt(att)">{{att.fileName}}</a></td>
                                            <td>
                                                <v-icon @click="deleteAtt(att)" color="red">delete
                                                </v-icon>
                                            </td>
                                        </tr>
                                    </table>
                                    <file-view
                                            :editable="false"
                                            accept=".pdf, image/*"
                                            :attachId="attachId"
                                            :attachType="attachType"
                                            @change="uploadNewFile"
                                    />

                                </v-flex>
                                <v-flex xs12 sm12 md4 lg4 xl4 style="padding:0px 10px">
                                    <v-text-field append-icon="group" v-validate="'required'"
                                                  :label="$t('lang.exercise.name')"
                                                  maxlength="200"
                                                  :disabled="exercise.questionId != null"
                                                  v-model="exercise.name"
                                                  name="name"
                                                  :data-vv-as="$t('lang.exercise.name')"
                                                  :error-messages="errors.first('name')"
                                    />
                                    <v-textarea
                                            label="Hướng dẫn làm bài"
                                            v-model="exercise.guideline"
                                            name="guideline"
                                            maxlength="500"
                                            :error-messages="errors.first('guideline')"
                                    />

                                    <!--v-text-field append-icon="code" v-validate="'required'"
                                                  :label="$t('lang.exercise.subject')"
                                                  maxlength="200"
                                                  v-model="exercise.subject"
                                                  :data-vv-as="$t('lang.exercise.subject')"
                                                  name="subject"
                                                  :error-messages="errors.first('subject')"/>
                                    <v-datetime-picker :label="$t('lang.exercise.effectiveDate')"
                                                       locale="vi"
                                                       v-validate="'required'"
                                                       type="datetime-local"
                                                       :data-vv-as="$t('lang.exercise.effectiveDate')"
                                                       name="effectiveDate"
                                                       key="effectiveDate"
                                                       ref="effectiveDate"
                                                       v-model="exercise.effectiveDate"
                                                       :error-messages="errors.first('effectiveDate')"> </v-datetime-picker-->
                                    <i-datepicker :label="$t('lang.exercise.dueDate')"
                                                  v-if="exercise.questionId != null && exercise.receivers!= null"
                                                  key="dueDateNo"
                                                  v-model="exercise.dueDate"
                                                  v-validate="'required|date_format:yyyy-MM-dd'"
                                                  :data-vv-as="$t('lang.exercise.dueDate')"
                                                  name="dueDateNo"
                                                  :error-messages="errors.first('dueDateNo')"
                                    />
                                    <i-datepicker :label="$t('lang.exercise.dueDate')"
                                                  v-model="exercise.dueDate"
                                                  v-else
                                                  key="dueDateSe"
                                                  v-validate="'required|date_format:yyyy-MM-dd|date_after_now'"
                                                  :data-vv-as="$t('lang.exercise.dueDate')"
                                                  name="dueDateSe"
                                                  :error-messages="errors.first('dueDateSe')"
                                    />

                                    <!--v-select append-icon="supervised_user_circle"
                                              :label="$t('lang.exercise.receivers')"
                                              height="40px"
                                              :items="classMember"
                                              item-text="fullName"
                                              item-value="userId"
                                              multiple
                                              chips
                                              v-model="receivers"
                                              :data-vv-as="$t('lang.exercise.receivers')"
                                              name="receivers"
                                              :error-messages="errors.first('receivers')"/>
                                    <v-text-field append-icon="code" v-validate="'required|numeric'"
                                                  :label="$t('lang.exercise.markScale')"
                                                  maxlength="4"
                                                  v-model="exercise.markScale"
                                                  :data-vv-as="$t('lang.exercise.markScale')"
                                                  name="markScale"
                                                  :error-messages="errors.first('markScale')"/-->
                                    <v-text-field append-icon="access_time" v-validate="'numeric'"
                                                  maxlength="4"
                                                  :label="$t('lang.exercise.questionTime')"
                                                  :data-vv-as="$t('lang.exercise.questionTime')"
                                                  v-model="exercise.questionTime"
                                                  name="questionTime"
                                                  :error-messages="errors.first('questionTime')"/>
                                    <v-select append-icon="supervised_user_circle"
                                              label="Cho phép học sinh"
                                              height="40px"
                                              :items="studentPermission"
                                              item-text="name"
                                              item-value="value"
                                              chips
                                              v-model="exercise.permission"
                                              data-vv-as="Cho phép học sinh"
                                              name="permission"
                                              @change="refreshAnswerAtt"
                                              :error-messages="errors.first('permission')"/>
                                    <i-upload v-if="viewAnswerAtt" name="answerAttachId" v-validate="'required'"
                                              v-model="exercise.answerAttachId" label="Lời giải"
                                              @change="changeAnswerDetail"/>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="cancel" @click="cancel">
                            {{ $t('lang.common.cancel') }}
                        </v-btn>
                        <v-btn class="yoprimary" dark @click.once="onSave" v-if="$store.state.auth.user.role==4">
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn class="info" dark @click="onSend"
                               v-if="$store.state.auth.user.role==4 && (exercise.receivers == null || exercise.receivers == '')">
                            {{$t('lang.class.sendToStudent')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <library-question v-model="showLibary" exercise-type="5" @onSelect="selectQuestionFromLibrary"/>
        <send-to-member :class-id="classId" @send="onChangeReceiver" ref="sendDialog"/>
    </div>
</template>

<script>
    import {message} from '../../services';
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios"
    import IUpload from "../../components/form/Upload";
    import FileView from "./fileView";
    import LibraryQuestion from "./libraryQuestion";
    import {Validator} from "vee-validate";
    import moment from "moment";
    import SendToMember from "./sendToMember";

    export default {
        name: "essay-create",
        components: {
            SendToMember,
            LibraryQuestion,
            FileView,
            IUpload,
            IDatepicker,
        },

        props: {
            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },

            question: {
                type: Object,
                default: () => {
                    return null;
                }
            }

        },
        data() {
            return {
                viewAnswerAtt: false,
                clazz: {},
                accept: ".pdf, .doc, .docx, image/*",
                receivers: [],
                classMember: [],
                attachId: null,
                attachType: null,
                exercise: {
                    "name": "",
                    "subject": "",
                    "dueDate": null,
                    "effectiveDate": null,
                    "markScale": 10,
                    "content": "",

                },
                showLibary: false,
                subjects: [],
                grades: [],
                attachs: [],
                attachId: null,
                attachType: null,
                studentPermission: [
                    {name: "Chỉ xem điểm", value: 0},
                    {name: "Xem lời giải chi tiết", value: 1},
                ]
            }
        },

        computed: {
            /*
                        attachId:function(){
                            return this.exercise.attachId;
                        },
                        attachType:function(){
                            return this.exercise.attachType;
                        }
            */
        },

        watch: {

            receivers: function (data) {
                if (this.receivers[this.receivers.length - 1] == 0) {
                    if (this.receivers.length > 1) {
                        this.receivers = [0];
                    }
                } else {
                    for (let i = this.receivers.length - 1; i >= 0; i--) {
                        if (this.receivers[i] == 0) {
                            this.receivers.splice(i, 1);
                        }
                    }
                }
            }
        },

        created() {
            //console.log(this.question);
            axios.post(process.env.VUE_APP_API_URL + "/class/getStudentOfClass?classId=" + this.classId).then(
                data => {
                    this.classMember = [{'fullName': "Tất cả", 'userId': 0}, ...data];
                },
                error => {
                    console.log(error);
                }
            )
            if (this.question != null) {
                this.initFromQuestion(this.question);
            } else {
                this.receivers = [0];
            }
        },

        mounted: function () {
            Validator.extend("dueDateAfter", {
                validate: (value, {otherValue}) => {
                    let mm = moment(value).hour(23).minute(59).second(59);
                    let valid = mm.isSameOrAfter(this.exercise.effectiveDate); // false
                    return {
                        valid: valid,
                    };
                },
                getMessage: (field, params, data) => {
                    return "Ngày đến hạn phải sau Ngày có hiệu lực";
                }
            });
        },

        methods: {
            initFromQuestion: function (question) {
                this.exercise = question;
                this.exercise.dueDate = question.dueDate;
                this.exercise.effectiveDate = question.effectiveDate;
                if (question.receivers != null && question.receivers != "") {
                    let arr = question.receivers.split(",");
                    this.receivers = [];
                    for (let i = 0; i < arr.length; i++) {
                        if (!isNaN(arr[i])) {
                            this.receivers.push(parseInt(arr[i]));
                        }
                    }
                }
                this.attachId = this.exercise.attachId;
                this.attachType = this.exercise.attachType;
                if (question.attachs == undefined || question.attachs == null) {
                    this.attachs = [];
                } else {
                    this.attachs = JSON.parse(question.attachs);
                    if (this.attachs.length > 0) {
                        this.attachId = this.attachs[0].attachId;
                        this.attachType = this.attachs[0].type;
                    }
                }
                if (this.exercise.permission == 0 || this.exercise.permission == null || this.exercise.permission == undefined) {
                    this.viewAnswerAtt = false;
                } else {
                    this.viewAnswerAtt = true;
                }
            },

            onChangeReceiver: function (receivers) {
                this.receivers = receivers;
                this.save();
            },

            onSend: function () {
                this.$refs.sendDialog.show();
            },

            onSave() {
                this.receivers = [];
                this.save();
            },

            save() {
                this.$validator.validate().then(valid => {
                    //console.log(valid);
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    //console.log(this.class);
                    if (this.receivers != null && this.receivers.length > 0) {
                        let ids = this.receivers[0];
                        for (let i = 1; i < this.receivers.length; i++) {
                            ids += "," + this.receivers[i];
                        }
                        this.exercise.receivers = ids;
                    } else {
                        this.exercise.receivers = null;
                    }
                    this.exercise.attachs = JSON.stringify(this.attachs);
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/saveEssay?classId=" + this.classId, this.exercise).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.cancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            console.log(error);
                        }
                    );
                });
            },

            fromLocal: function () {
                this.openFileDialog();
            },

            fromLibary: function () {
                this.showLibary = true;
            },

            selectQuestionFromLibrary: function (libQuestion) {
                /*
                                console.log(libQuestion);
                */
                libQuestion.questionId = null;
                libQuestion.status = 0;
                libQuestion.receivers = null;
                this.initFromQuestion(libQuestion);
            },

            cancel: function () {
                this.$emit("onCancelCreate");
            },

            viewAtt: function (att) {
                console.log(att);
                this.attachType = att.type;
                this.attachId = att.attachId;
            },

            deleteAtt: function (att) {
                for (let i = 0; i < this.attachs.length; i++) {
                    if (this.attachs[i].attachId == att.attachId) {
                        this.attachs.splice(i, 1);
                        break;
                    }
                }
                if (this.attachId == att.attachId) {
                    console.log("sdfsdf");
                    if (this.attachs.length > 0) {
                        this.attachType = this.attachs[0].type;
                        this.attachId = this.attachs[0].attachId;
                    } else {
                        this.attachType = null;
                        this.attachId = null;
                    }
                }
            },

            changeAnswerDetail(data) {
                this.exercise.answerAttachId = data.id;
                this.exercise.answerAttachType = data.type;
            },

            uploadNewFile: function (data) {
                this.exercise.attachId = data.id;
                this.exercise.attachType = data.type;
                let md = {
                    url: process.env.VUE_APP_API_URL + "/download/attach/" + data.id,
                    attachId: data.id,
                    type: data.type,
                    fileName: data.fileName
                }
                this.attachId = data.id;
                this.attachType = data.type;
                if (this.attachs == null) {
                    this.attachs = [md];
                } else {
                    this.attachs.push(md);
                }
            },

            openFileDialog() {
                document.getElementById("essayUpload").click();
            },

            uploadFile: function (e) {
                let formData = new FormData();
                formData.append("uploadfile", this.fileContent);
                formData.append("sourceId", "");
                formData.append("sourceType", "1");
                formData.append("attachTitle", "");
                axios.post(process.env.VUE_APP_API_URL + "/upload/save", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(
                    data => {
                        console.log(data);
                        this.exercise.attachId = data.id;
                        this.exercise.attachType = this.fileType;
                        this.attachId = this.exercise.attachId;
                        this.attachType = this.exercise.attachType;
                        //console.log(this.exercise);
                        let md = {
                            url: process.env.VUE_APP_API_URL + "/download/attach/" + data.id,
                            attachId: data.id,
                            type: this.fileType,
                            fileName: this.fileName
                        }
                        if (this.attachs == null) {
                            this.attachs = [md];
                        } else {
                            this.attachs.push(md);
                        }

                        message.success("upload thành công");
                    },
                    error => {
                        message.error("upload không thành công");
                        e.target.value = "";
                    }
                );
            },

            onFilePicked: function (e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    //console.log(files[0]);
                    this.fileName = files[0].name;
                    this.fileType = files[0].type;
                    if (this.fileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.fileURL = fr.result;
                        this.fileContent = files[0]; // this is an file that can be sent to server...
                        this.uploadFile(e);
                    })
                }
            },
            refreshAnswerAtt() {
                if (this.exercise.permission == 0) {
                    this.viewAnswerAtt = false;
                } else {
                    this.viewAnswerAtt = true;
                }
            },
        }
    };
</script>

